import React, { useState, useEffect, useRef } from "react";
import { Spin, Modal, Skeleton } from "antd";
import {
  getChatTopicHistoryAPI,
  getGlobalSearchChatAPI,
  getTopicChatsAPI,
} from "../../redux/actions/ChatWithData/ChatWithDataApi";
import { useDispatch, useSelector } from "react-redux";
import {
  setChattopicsHistory,
  setSelectedChatData,
} from "../../redux/actions/ChatWithData/ChatWithData";
import { LoadingOutlined } from "@ant-design/icons";
import useDebounce from "../utils/useDebounce";
import searchChatIcon from "../../assets/ChatWithData/search_chat_icon.svg";
import { setOptionHighChart } from "../../redux/actions/HighChart";
import moment from "moment";

const SearchModal = ({ isModalOpen, setSearchModalEnabled }) => {
  const scrollContainerRef = useRef(null); // Ref to the scroll container
  const dispatch = useDispatch();
  const chatTopicsHistory = useSelector(
    (state) => state?.ChatWithData?.chat_topics_history
  );
  const globalSearchChatList = useSelector(
    (state) => state?.ChatWithData?.global_search_chat_list
  );
  const globalSearchChatLoader = useSelector(
    (state) => state?.ChatWithData?.global_search_chat_loader
  );
  const selectedChatTopics = useSelector(
    (state) => state?.ChatWithData?.selected_chat_data
  );

  let p_token = localStorage.getItem("p_token");

  const [searchText, setSearchText] = useState(null);
  const debouncedUpdateTitle = useDebounce(searchText, 1000);

  const [showTimeStamp, setShowTimeStamp] = useState({
    flag: false,
    session_name: null,
    session_id: null,
    index: null,
  });

  useEffect(() => {
    let payloadObj = {
      p_token: p_token ? p_token : null,
      search_text: searchText ? searchText : null,
    };
    dispatch(getGlobalSearchChatAPI(payloadObj));
  }, []);

  useEffect(() => {
    if (window.location.pathname === "/chat-with-data") {
      if (debouncedUpdateTitle) {
        let payloadObj = {
          p_token: p_token ? p_token : null,
          search_text: searchText ? searchText : null,
        };
        dispatch(getGlobalSearchChatAPI(payloadObj));
      } else {
        if (debouncedUpdateTitle === "") {
          let payloadObj = {
            p_token: p_token ? p_token : null,
            search_text: searchText ? searchText : null,
          };
          dispatch(getGlobalSearchChatAPI(payloadObj));
        }
      }
    }
  }, [debouncedUpdateTitle]);

  const handleCancel = () => {
    setSearchModalEnabled(false);
  };

  const handleSearchChat = (text) => {
    setSearchText(text);
  };

  const handleGetTopicChats = (chat) => {
    if (chat?.session_id !== selectedChatTopics?.session_id) {
      // Reset State Highcharts
      dispatch(setOptionHighChart(null));

      // console.log("Inside handleGetTopicChats", chat?.session_id);
      let payloadObj = {
        session_id: chat?.session_id,
        offset: 0,
        p_token: p_token ? p_token : null,
      };
      // API Call
      dispatch(getTopicChatsAPI(payloadObj));

      // Store Selected chat data
      dispatch(setSelectedChatData(chat));

      setSearchModalEnabled(false);
    }
  };

  const handleOnMouseEnter = (index, session_name, session_id) => {
    setShowTimeStamp({
      flag: true,
      session_name: session_name,
      session_id: session_id,
      index: index,
    });
  };

  const handleOnMouseLeave = (index, session_name, session_id) => {
    setShowTimeStamp({
      flag: false,
      session_name: null,
      session_id: null,
      index: null,
    });
  };

  return (
    <>
      <Modal
        centered
        className="custom_modal_container-search"
        open={isModalOpen}
        onCancel={handleCancel}
        closable={true}
        // width={"60%"}
        styles={{ header: { borderBottom: "none" } }}
        footer={false}
      >
        <div className="search-modal-container">
          <input
            className="search-modal-input"
            placeholder="Search chats"
            onChange={(e) => handleSearchChat(e?.target?.value)}
          />
          <div className="search-modal-div custom_scroll1">
            <div>
              {globalSearchChatLoader ? (
                <div className="search-modal-loader-div">
                  <Skeleton
                    active
                    avatar={{ size: 30 }}
                    paragraph={{
                      rows: 1,
                    }}
                    className="search-modal-loader-div-skeleton"
                  />
                  <Skeleton
                    active
                    avatar={{ size: 30 }}
                    paragraph={{
                      rows: 1,
                    }}
                    className="search-modal-loader-div-skeleton"
                  />
                  <Skeleton
                    active
                    avatar={{ size: 30 }}
                    paragraph={{
                      rows: 1,
                    }}
                    className="search-modal-loader-div-skeleton"
                  />
                </div>
              ) : globalSearchChatList === "No results found." ? (
                <div className="h-100">
                  <p className="chat-history-not-found">No result found</p>
                </div>
              ) : globalSearchChatList?.length ? (
                <>
                  {globalSearchChatList?.map((chat, index) => {
                    return (
                      <div
                        key={chat?.session_id || index}
                        onClick={() => handleGetTopicChats(chat)}
                        onMouseEnter={() =>
                          handleOnMouseEnter(
                            index,
                            chat?.session_name,
                            chat?.session_id
                          )
                        }
                        onMouseLeave={() =>
                          handleOnMouseLeave(
                            index,
                            chat?.session_name,
                            chat?.session_id
                          )
                        }
                        className="search-modal-session-container"
                      >
                        <img
                          className="search-modal-session-img"
                          src={searchChatIcon}
                        />
                        <div className="search-modal-session-name-parent">
                          <p
                            className={`${
                              searchText
                                ? "search-modal-session-name-searched"
                                : "search-modal-session-name"
                            }`}
                          >
                            <HighlightText
                              text={chat?.session_name}
                              highlight={searchText}
                            />
                          </p>
                          {searchText ? (
                            <p className="search-modal-session-question">
                              <HighlightText
                                text={chat?.question}
                                highlight={searchText}
                              />
                            </p>
                          ) : (
                            ""
                          )}
                        </div>

                        {searchText &&
                        showTimeStamp?.flag &&
                        showTimeStamp?.index === index &&
                        showTimeStamp?.session_name === chat?.session_name &&
                        showTimeStamp?.session_id === chat?.session_id ? (
                          <div className="search-modal-session-timestamp">
                            {moment(chat?.session_date)?.format("D MMM")}
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                    );
                  })}
                </>
              ) : (
                <p className="chat-history-not-found">Chat not found</p>
              )}
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

const HighlightText = ({ text, highlight }) => {
  if (!highlight?.trim()) return <span>{text}</span>;

  const safeHighlight = highlight.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
  const regex = new RegExp(`(${safeHighlight})`, "gi");
  const parts = text?.split(regex);

  return (
    <span>
      {parts?.map((part, index) =>
        regex?.test(part) ? (
          <span key={index} style={{ fontWeight: "bold", color: "#fff" }}>
            {part}
          </span>
        ) : (
          part
        )
      )}
    </span>
  );
};
export default SearchModal;
